/**
 * Client-side Excel export via SheetJS (xlsx).
 * Lazy-loads the library so list pages don't pay for it until Export is clicked.
 */
export async function exportRowsToExcel(filename, rows, columns) {
  const XLSX = await import('xlsx');
  const header = columns.map((c) => c.header);
  const body = (rows || []).map((row) =>
    columns.map((c) => {
      const v = typeof c.value === 'function' ? c.value(row) : row[c.field];
      if (v == null) return '';
      return typeof v === 'object' ? String(v) : v;
    })
  );
  const sheet = XLSX.utils.aoa_to_sheet([header, ...body]);
  const book = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(book, sheet, 'Data');
  const safe = String(filename || 'export').replace(/[^\w.-]+/g, '_');
  XLSX.writeFile(book, safe.endsWith('.xlsx') ? safe : `${safe}.xlsx`);
}
